// extracted by mini-css-extract-plugin
module.exports = {"notificationWrapper":"XS","disabled":"YS"};